import React, { useState, useEffect } from 'react';
import '../../css/Components/NavBarMobile/NavBarMobile.css'

import { Link as Anchor, useNavigate, useLocation } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartPie, faShoppingCart, faSearch, faHome, faPlus, faUser } from '@fortawesome/free-solid-svg-icons';
import BtnWhatsapp from '../BtnWhatsapp/BtnWhatsapp'
import Cart from '../Cart/Cart'
import Favoritos from '../Favoritos/Favoritos'
import InputSearch from '../InputSearch/InputSearch'
export default function NavbarMobile() {
    const location = useLocation();
    const [modalOpen, setModalOpen] = useState(false);


    const openModal = () => {
        setModalOpen(!modalOpen);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    return (
        <section className='scrolledMobile'> 
            <Anchor to={`/`} className={location.pathname === '/' ? 'active' : ''} onClick={closeModal}  >
                <FontAwesomeIcon icon={faHome} />
                <strong>Inicio</strong>

            </Anchor>
            < BtnWhatsapp />
            {/* <button to={`/`} className='plus'>
                <Cart />
            </button> */}
            <a href={`/`} className='plus'>
                <Cart />
            </a>
            <Favoritos />
            <InputSearch />


        </section>
    );
}
